import React from 'react'
import { useState } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import Navbar from './component/Navbar'
import Scroller from './component/Scroller'
import Sidebar from './component/Sidebar'
import ChannelDetail from './pages/ChannelDetail'
import Feed from './pages/Feed'
import SearchFeed from './pages/SearchFeed'
import VideoDetail from './pages/VideoDetail'


const App = () => {
  const [sidebar, setSidebar] = useState(false)
  const toogelSidebar = () => {
    setSidebar((prevState) => !prevState)
  }
  return (
    <div id='main_app_container'>
      <BrowserRouter>
        <Navbar openSidebar={toogelSidebar} />
       
        <Sidebar sidebar={sidebar} >
          <Routes>
            <Route path='/' element={<Feed />} />
            <Route path='/video/:id' element={<VideoDetail />} />
            <Route path='/channel/:id' element={<ChannelDetail />} />
            <Route path='/search/:searchTerm' element={<SearchFeed />} />

          </Routes>
        </Sidebar>

      </BrowserRouter>

    </div>
  )
}

export default App







